var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c(
      "div",
      {
        staticClass:
          "h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",
        style: {
          "background-image": "url(" + _vm.imagenFondo + ") !important",
          "background-attachment": "fixed",
          overflow: "scroll"
        },
        attrs: { id: "management" }
      },
      [
        _c(
          "div",
          [
            _vm.ingresoLogo
              ? _c("img", {
                  style: _vm.logoStyle,
                  attrs: {
                    src: _vm.ingresoLogo.imagen,
                    id: "logo",
                    alt: "logo"
                  }
                })
              : _vm._e(),
            _c("h4", { staticClass: "mb-5 text-white text-center" }, [
              _vm._v(" Verificación de identidad para firma electrónica ")
            ]),
            _c(
              "b-card",
              [
                _c("verification-form-external-sign-api", {
                  attrs: { cuUserData: _vm.cuUserData },
                  on: { completed: _vm.onCompleted }
                })
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }